import AbstractItemBuilderView from './AbstractItemBuilderView';
import ItemMouseEvent from '../ItemMouseEvent';
import Modal from '../Modal';
import { ItemBuilderAction } from './ItemBuilderView';
import { Item, ItemType } from '../Item';
import ItemView from '../ItemView';
import $ from 'jquery';

class StandardItemBuilderView extends AbstractItemBuilderView {
  private listFlag = false;

  constructor(args: { el: string; model: Modal<Item> }) {
    super(args);
  }

  protected mousemove(event: ItemMouseEvent): void {
    if (Math.abs(this.getPositionX() - event.position.x) > 15 || Math.abs(this.getPositionY() - event.position.y) > 15) {
      if (this.viewState.action != ItemBuilderAction.DRAG && this.viewState.current && this.viewState.current.getModel().value?.type != 'Breadcrumb') {
        const clone = $(this.viewState.current.getParentNode()).clone();
        $(clone).attr('id', `deleted_${this.viewState.current.getParentNode().substring(1, this.viewState.current.getParentNode().length)}`);
        $(this.viewState.current.getParentNode()).append(clone);
        $(`#deleted_${this.viewState.current.getParentNode().substring(1, this.viewState.current.getParentNode().length)}`)
          .css('position', 'unset')
          .css('left', 'unset')
          .css('top', 'unset');
      }

      if (this.viewState.current) {
        this.viewState.action = ItemBuilderAction.DRAG;
      }

      if (event.component && this.viewState.current) {
        this.viewState.target = event.component;
      }

      if (event.component == undefined && this.viewState.current) {
        this.viewState.target = undefined;
      }

      if (this.viewState.action == ItemBuilderAction.DRAG && this.viewState.current && this.viewState.current.getModel().value?.type != 'Breadcrumb') {
        switch (this.viewState.current.getModel().value?.type) {
          case ItemType.FOLDER:
            this.onMoveFolder(event);
            break;
          case ItemType.LIST:
            this.onMoveList(event);
            break;
        }
      }
    }
  }

  protected pointerUp(event: ItemMouseEvent): void {
    if (event.component && this.viewState.current) {
      this.viewState.target = event.component;
      this.setLastTarget(this.viewState.target.getModel());
      this.setLastCurrent(this.viewState.current.getModel());
      this.rerender();
    } else {
      this.viewState.target = undefined;
    }
    if (this.viewState.current) {
      switch (this.viewState.current.getModel().value?.type) {
        case ItemType.FOLDER:
          this.onPointerUpFolder();
          break;
        case ItemType.LIST:
          this.onPointerUpList();
          break;
        case ItemType.BREADCRUMB:
          break;
      }
      $(`#deleted_${this.viewState.current.getParentNode().substring(1, this.viewState.current.getParentNode().length)}`).remove();
    }
    this.viewState = {
      action: ItemBuilderAction.FREE,
    };
  }

  protected pointerDown(event: ItemMouseEvent): void {
    this.setPositionX(event.position.x);
    this.setPositionY(event.position.y);
    if (event.component) {
      this.viewState.current = event.component;
    }
  }

  protected insert(current: ItemView, target: ItemView) {
    this.rerender();
  }

  private onPointerUpFolder = () => {
    if (this.viewState.current) {
      const element = $(this.viewState.current.getNode());
      element
        .css('display', 'flex')
        .css('position', 'relative')
        .css('left', 'unset')
        .css('top', 'unset')
        .css('height', '100px')
        .css('width', '120px')
        .css('pointer-events', 'unset')
        .css('opacity', '1')
        .css('z-index', '50');
      const folderCountLabel = document.getElementById(`folder_${this.viewState.current.getModel().value?.payload.id}_label`);
      const targetLabelContainer = document.getElementById(`folder_to_target_folder_${this.viewState.current.getModel().value?.payload.id}_label`);
      if (folderCountLabel) {
        folderCountLabel.setAttribute('style', 'opacity: 0 !important');
      }
      if (targetLabelContainer) {
        targetLabelContainer.setAttribute('style', 'opacity: 0 !important');
        $('target-label').css('opacity', '0 !important');
      }
    }
  };

  private onPointerUpList = () => {
    const doc = $('#list-animate');
    if (doc) {
      doc.css('position', 'absolute').css('visible', 'hidden').css('left', 'unset').css('top', 'unset').css('border', 'unset');

      const label = $('#list-animate-name');
      if (label) {
        label.remove();
      }
    }
    if (this.viewState.current) {
      const element = $(this.viewState.current.getNode());
      element.css('display', 'flex').css('left', 'unset').css('top', 'unset').css('pointer-events', 'unset').css('z-index', '50');
    }
    this.listFlag = false;
  };

  private onMoveFolder = (event: ItemMouseEvent) => {
    if (this.viewState.current) {
      $(this.viewState.current.getNode())
        .css('position', 'absolute')
        .css('pointer-events', 'none')
        .css('opacity', '0.5')
        .css('width', '75px')
        .css('height', '75px')
        .css('z-index', '1001');
      const targetLabelContainer = document.getElementById(`folder_to_target_folder_${this.viewState.current.getModel().value?.payload.id}_label`);
      if (targetLabelContainer && this.viewState.target != undefined) {
        targetLabelContainer.setAttribute('style', 'opacity: 1');
      }
      if (targetLabelContainer && this.viewState.target == undefined) {
        targetLabelContainer.setAttribute('style', 'opacity: 0');
      }
      if (this.viewState.target != undefined && targetLabelContainer) {
        if (this.viewState.target.getModel()?.value?.type == ItemType.LIST && this.viewState.current?.getModel()?.value?.type == ItemType.FOLDER) {
          $('p[id=target-label]').remove();
          $(targetLabelContainer).append(
            `<p id="target-label" class="text-xs text-white w-full truncate opacity-100 px-1 py-1 ">${'You can not move folder to card'}</p>`,
          );
        } else {
          $('p[id=target-label]').remove();
          $(targetLabelContainer).append(
            `<p id="target-label" class="text-xs text-white w-full truncate opacity-100 px-1 py-1 ">${'Taşıma Yeri: ' + this.viewState.target.getModel().value?.payload.name}</p>`,
          );
        }
      }
      const folderCountLabel = document.getElementById(`folder_${this.viewState.current.getModel().value?.payload.id}_label`);
      if (folderCountLabel) {
        folderCountLabel.setAttribute('style', 'opacity: 1');
      }
      $(`folder_${this.viewState.current.getModel().id}_label`).css('opacity', '1');
      this.viewState.current.renderPosition(event.position);
    }
  };

  private onMoveList = (event: ItemMouseEvent) => {
    if (this.viewState.current) {
      const doc = $('#list-animate');
      if (doc) {
        doc.css('position', 'absolute').css('display', 'flex').css('left', event.position.x).css('top', event.position.y);
        if (!this.listFlag) {
          doc.append(`<div id="list-animate-name">${this.viewState.current?.getModel()?.value?.payload.name}</div>`);
        }
      }
      if (this.viewState.target) {
        if (this.viewState.target?.getModel()?.value?.type == ItemType.FOLDER || this.viewState.target?.getModel()?.value?.type == ItemType.BREADCRUMB) {
          doc.css('border', '1px solid #728EFF70');
        } else {
          doc.css('border', '1px solid #D2332F70');
        }
      } else {
        doc.css('border', '1px solid #D2332F70');
      }
      $(this.viewState.current.getNode()).css('position', 'absolute').css('pointer-events', 'none').css('opacity', '1');
      this.viewState.current.renderPosition(event.position);
    }
    this.listFlag = true;
  };

  private getItemName = (item: ItemView) => {
    let name = item.getModel().value?.payload.name;
    if (item.getModel().value?.type == ItemType.BREADCRUMB) {
      name = item.getModel().value?.title;
    }
    return `Taşıma Yeri: ${name}`;
  };
}

export default StandardItemBuilderView;
